module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAASdJREFUaEPtWLENwkAM/JdSswVFmAIoQCmyDBMwAcukQFAAU5CCLVJHeiqaiI/973fCi0vrnO27sx0p1mT+2Mz7NyAwt4Nw4OcduDxaN2eT+3U5OiXkCIGA0D44IBRQHU7ugHoHwgIgIBRQDCcdwBkVaowzmv0ICSdAHU4usXoHwgIgIBRQDPc6cL63x5js1aYcxaXOCwJDl+CAZ259wrBHyJcgdqY/fXLzggBXqdDLxc0LB6jrEqo89f5wt9QcoBqJjYMAV4FYhSkct774O0A1EhsHAa4CsQpTOG79/xkhSjHtuPg7oN0glT+cwK09GGsWVOJJ4s501bY8favl3YHm+lwWha1nJ+FM1/euqXerVxCBSZRNUAS/VRKIKEoBB0TyJQBn78AbAq3IMToinUoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/base.png
// module id = LZGn
// module chunks = 0